import React from 'react'
import { Grid, Container, Avatar } from '@mui/material'

import SettingsIcon from '@mui/icons-material/Settings'

import { useSelector, useDispatch } from 'react-redux'

import { CustomTitle } from '../../common/CustomTitle/CustomTitle'
import { ThresholdsEditor } from './ThresholdsEditor'

import {
  contractsCmAdaptativeThresholdsSunrise,
  contractsCmAdaptativeThresholdsSunset
} from '../../../reducers/contracts/contractsReducer'

export const DynamicConfigurationScreen = () => {
  const dispatch = useDispatch()

  const thresholdsSunrise = useSelector(state => state.contracts.cmAdaptativeThresholdsSunrise)
  const thresholdsSunset = useSelector(state => state.contracts.cmAdaptativeThresholdsSunset)

  function handleSaveSunrise(levels) {
    dispatch(contractsCmAdaptativeThresholdsSunrise(levels))
  }

  function handleSaveSunset(levels) {
    dispatch(contractsCmAdaptativeThresholdsSunset(levels))
  }

  return (
    <Container
      maxWidth={false}
      sx={{
        p: 2
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <CustomTitle
            title={'Configuración'}
            icon={
              <Avatar>
                <SettingsIcon />
              </Avatar>
            }
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <ThresholdsEditor
            title={'Niveles de luminosidad ~ Orto'}
            thresholds={thresholdsSunrise}
            onSave={handleSaveSunrise}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <ThresholdsEditor
            title={'Niveles de luminosidad ~ Ocaso'}
            thresholds={thresholdsSunset}
            onSave={handleSaveSunset}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
